
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import AuthProvider from './components/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import { config } from './app/config';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <GoogleOAuthProvider clientId={config.googleClientId}>
    <AuthProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </AuthProvider>
    </GoogleOAuthProvider>
  </StrictMode>
);
